import * as tslib_1 from "tslib";
import { EventEmitter, ViewContainerRef } from '@angular/core';
import { InputConverter } from '../../../inputConverter';
import { BaseComponent } from '../../base.component';
var BaseSymbolEditorComponent = /** @class */ (function (_super) {
    tslib_1.__extends(BaseSymbolEditorComponent, _super);
    function BaseSymbolEditorComponent(_vcr, layerService) {
        var _this = _super.call(this, _vcr) || this;
        _this.applyColorToEntireLayerChange = new EventEmitter();
        _this.colorChange = new EventEmitter();
        _this.applyColorToEntireLayer = false;
        _this.multipleSymbols = false;
        _this.cancel = function () {
            _this.uniqueLayerId = null;
            _this.layerSymbol = null;
        };
        _this.layerService = layerService;
        return _this;
    }
    Object.defineProperty(BaseSymbolEditorComponent.prototype, "uniqueLayerId", {
        get: function () {
            return this._uniqueLayerId;
        },
        set: function (value) {
            this._uniqueLayerId = value;
            if (value) {
                this.esriLayer = this.layerService.getEsriLayerByUniqueId(this.uniqueLayerId);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BaseSymbolEditorComponent.prototype, "layerSymbol", {
        get: function () {
            return this._layerSymbol;
        },
        set: function (value) {
            this._layerSymbol = value;
            this.bindForm();
        },
        enumerable: true,
        configurable: true
    });
    BaseSymbolEditorComponent.prototype.bindForm = function () {
        this.symbolColor = this.originalColor;
    };
    BaseSymbolEditorComponent.prototype.updateColorFromPicker = function (evt, colorProperty) {
        if (colorProperty === void 0) { colorProperty = 'symbolColor'; }
        this[colorProperty] = evt;
        if (this.applyColorToEntireLayer && this.outlineColor) {
            this.outlineColor = evt;
        }
        if (colorProperty === 'symbolColor') {
            this.colorChange.emit(evt);
        }
    };
    BaseSymbolEditorComponent.prototype.applyColorToEntireLayerCheckboxChange = function () {
        if (this.applyColorToEntireLayer) {
            this.applyColorToEntireLayerChange.emit(true);
            this.colorChange.emit(this.symbolColor);
            this.outlineColor = this.symbolColor;
        }
        else {
            this.applyColorToEntireLayerChange.emit(false);
        }
    };
    BaseSymbolEditorComponent.prototype.cancelColorChange = function (colorProperty) {
        if (colorProperty === void 0) { colorProperty = 'symbolColor'; }
        switch (colorProperty) {
            case 'layerColor':
                this.esriLayer.mapcoreProps.color = this.originalColor;
                break;
            case 'outlineColor':
                this.outlineColor = this.originalOutlineColor;
                break;
            default:
                this.symbolColor = this.originalColor;
                break;
        }
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], BaseSymbolEditorComponent.prototype, "multipleSymbols", void 0);
    return BaseSymbolEditorComponent;
}(BaseComponent));
export { BaseSymbolEditorComponent };
